import axios from 'axios';

// В Docker: nginx проксирует /api и /uploads на бэкенд → baseURL = ''
// Локально: Vite dev server на 5173, бэкенд на 8000 → baseURL = 'http://127.0.0.1:8000'
// Local: .env.development sets http://localhost:8000
// Docker: ENV VITE_API_URL="" → empty = relative URLs (nginx proxies /api)
export const API_BASE = import.meta.env.VITE_API_URL || '';

export const api = axios.create({
  baseURL: `${API_BASE}/api/v1`,
});

const ACCESS_TOKEN_KEY = 'sharkly_access_token';

export const getAccessToken = (): string | null => {
  const sessionToken = sessionStorage.getItem(ACCESS_TOKEN_KEY);
  if (sessionToken) {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    return sessionToken;
  }

  const legacyToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (legacyToken) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, legacyToken);
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
  return legacyToken;
};

export const storeAccessToken = (accessToken: string): void => {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const clearAccessToken = (): void => {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const getHttpErrorStatus = (error: unknown): number | undefined =>
  axios.isAxiosError(error) ? error.response?.status : undefined;

export const logHttpError = (context: string, error: unknown): void => {
  const status = getHttpErrorStatus(error);
  const message = axios.isAxiosError(error)
    ? error.message.replace(/[\r\n]+/g, ' ')
    : 'Non-HTTP error';
  console.error(`${context}: status=${status ?? 'n/a'}; message=${message}`);
};

api.interceptors.request.use(config => {
  const accessToken = getAccessToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export interface Clan {
  id: number;
  name: string;
  display_name: string;
  emoji: string;
  base_color_hex: string;
  aura_color_hex: string;
}
